<form class="mat-elevation-z3" #dimensionsForm="ngForm">
  @for (shutter of shutters$ | async; track shutter; let index = $index) {
    <div class="inputs-container">
      <div class="input-label">
        @if ((shutters$ | async).length > 1) {
          <h4>{{ 'ROLLER_SHUTTER_LEGACY|Segment' | translate }} {{letters[index]}}</h4>
        }
        @if ((shutters$ | async).length === 1) {
          <h4>{{ 'ROLLER_SHUTTER_LEGACY|Wymiar rolety' | translate }}</h4>
        }
      </div>
      <div class="input-container">
        <mat-form-field>
                    <mat-label [ngClass]="{
                        'label-valid':
                            shutterSizeRangeFull[index]['minWidth'] <= shutter.realWidth
                            && shutterSizeRangeFull[index]['maxWidth'] >= shutter.realWidth
                            && this.showDimensionSizeRange
                        }">
            <div class="input-container__label">
              {{ 'ROLLER_SHUTTER_LEGACY|Szerokość' | translate }}
            </div>
            @if (shutterSizeRangeFull[index] && this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight) {
              <div class="input-container__label--extra">
                {{ 'ROLLER_SHUTTER_LEGACY|Pełny zakres rozmiarów' | translate }}
                {{ shutterSizeRangeFull[index]['minWidthMM'] }} -
                {{ shutterSizeRangeFull[index]['maxWidthMM'] }}
              </div>
            }
          </mat-label>
          <input
            matInput
            [iccDimensionsValidator]="shutter.realWidth"
            [isWidthDimension]="true"
            [rollerShutterIndex]="index"
            iccDimensionInput
            type="number"
            [name]="'shutter-width' + index"
            [ngModel]="shutter.realWidth"
            (ngModelChange)="shutter.realWidth = $event; updateDimensions(false, index)"
            [ngModelOptions]="{ updateOn: 'blur' }"
            [disabled]="(shutters$ | async).length === 1 && modalConfigurator"
            #shutterWidth="ngModel"
            [ngClass]="{ 'input-invalid': shutterWidth.invalid && this.showDimensionSizeRange, 'input-container__input':  this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight}"
            />
            @if (shutterWidth.invalid && !this.showDimensionSizeRange) {
              <mat-error>{{
                'ROLLER_SHUTTER_LEGACY|Podane wymiary są nieprawidłowe.' | translate
              }}</mat-error>
            }
            <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
            @if (shutterWidth.invalid && shutterSizeRange[index].width !== null && this.showDimensionSizeRange) {
              <mat-error >
                {{ shutterSizeRange[index].width }}
              </mat-error>
            }
            @if (!shutterWidth.invalid && shutterSizeRange[index].width !== null && this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight) {
              <mat-hint>
                {{ shutterSizeRange[index].width }}
              </mat-hint>
            }
            @if (this.showDimensionSizeRange && (!shutter.realWidth || !shutter.realHeight)) {
              <mat-hint>
                {{ 'ROLLER_SHUTTER_LEGACY|Pełny zakres rozmiarów' | translate }}
                {{ shutterSizeRangeFull[index]['minWidthMM'] }} -
                {{ shutterSizeRangeFull[index]['maxWidthMM'] }}
              </mat-hint>
            }
          </mat-form-field>
        </div>
        <div class="input-container">
          <mat-form-field>
            <mat-label
                        [ngClass]="{
                            'label-valid':
                                shutterSizeRangeFull[index]['minHeight'] <= shutter.realHeight
                                && shutterSizeRangeFull[index]['maxHeight'] >= shutter.realHeight
                                && this.showDimensionSizeRange
                        }"
              >
              <div class="input-container__label">
                @if (addBoxToHeight) {
                  <span [innerHTML]="'ROLLER_SHUTTER_LEGACY|Wysokość <b>wraz ze skrzynką</b>' | translate"></span>
                }
                @if (!addBoxToHeight) {
                  <span [innerHTML]="'ROLLER_SHUTTER_LEGACY|Wysokość <b>bez skrzynki</b>' | translate"></span>
                }
              </div>
              @if (!shutter.commonRail && shutterSizeRangeFull[index] && this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight) {
                <div class="input-container__label--extra" >
                  {{ 'ROLLER_SHUTTER_LEGACY|Pełny zakres rozmiarów' | translate }}
                  {{ shutterSizeRangeFull[index]['minHeightMM'] }} -
                  {{ shutterSizeRangeFull[index]['maxHeightMM'] }}
                </div>
              }
            </mat-label>
            <input
              matInput
              [iccDimensionsValidator]="shutter.realHeight"
              [isWidthDimension]="false"
              [rollerShutterIndex]="index"
              iccDimensionInput
              type="number"
              step="0.1"
              [name]="'shutter-length' + index"
                        [ngModel]="
                            this.addBoxToHeight
                                ? shutter.realHeight +
                                  this.configurationsService.conf.Current.RollerShutter.realBoxHeight
                                : shutter.realHeight
                        "
              (ngModelChange)="shutter.realHeight = $event; updateDimensions(true, index)"
              [ngModelOptions]="{ updateOn: 'blur' }"
              [disabled]="shutter.commonRail || modalConfigurator"
              #shutterLength="ngModel"
              [ngClass]="{'input-invalid': shutterLength.invalid && this.showDimensionSizeRange, 'input-container__input' : this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight}"
              />
              @if (shutterLength.invalid && !this.showDimensionSizeRange) {
                <mat-error>{{
                  'ROLLER_SHUTTER_LEGACY|Podane wymiary są nieprawidłowe.' | translate
                }}</mat-error>
              }
              @if (
                shutterLength.invalid &&
                shutterSizeRange[index].height !== null &&
                this.showDimensionSizeRange
                ) {
                <mat-error
                  >
                  {{ shutterSizeRange[index].height }}
                </mat-error>
              }
              @if (!shutterLength.invalid && shutterSizeRange[index].height !== null && this.showDimensionSizeRange && shutter.realWidth && shutter.realHeight) {
                <mat-hint>
                  {{ shutterSizeRange[index].height }}
                </mat-hint>
              }
              @if (this.showDimensionSizeRange && (!shutter.realWidth || !shutter.realHeight)) {
                <mat-hint>
                  {{ 'ROLLER_SHUTTER_LEGACY|Pełny zakres rozmiarów' | translate }}
                  {{ shutterSizeRangeFull[index]['minHeightMM'] }} -
                  {{ shutterSizeRangeFull[index]['maxHeightMM'] }}
                </mat-hint>
              }
              <span matSuffix>{{ dimensionUnit.unitSymbol }}</span>
            </mat-form-field>
          </div>
        </div>
      }
      @if (isInfoPageAvailable) {
        <p class="dimensions-info" (click)="openDimensionsInfoPage()">
          {{ 'ROLLER_SHUTTER_LEGACY|Jak mierzyć rolete?' | translate }} <mat-icon>info</mat-icon>
        </p>
      }
      @if (dimensionsInfo && (systemInfo$ | async)) {
        <p>
          <mat-icon>info</mat-icon>
          {{ systemInfo$ | async }}
        </p>
      }
      @if ((mosquito$ | async) && this.areStepsJoined) {
        <div id="mosquito-form">
          <form class="mosquito-form">
            <h4>{{ 'ROLLER_SHUTTER_LEGACY|Siatka antyinsektowa:' | translate }}</h4>
            @if (this.showDimensionSizeRange) {
              <h6>
                <p>
                  {{ 'ROLLER_SHUTTER_LEGACY|Zakres szerokości rolety:' | translate }}
                  {{ mosquitoSizeRange['minWidth'] }} - {{ mosquitoSizeRange['maxWidth'] }}
                </p>
                <p>
                  {{ 'ROLLER_SHUTTER_LEGACY|Zakres wysokości rolety:' | translate }}
                  {{ mosquitoSizeRange['minHeight'] }} - {{ mosquitoSizeRange['maxHeight'] }}
                </p>
              </h6>
            }
            @for (shutter of shutters$ | async; track shutter; let index = $index) {
              <mat-checkbox
                [name]="'shutter-mosquito-' + index"
                [ngModel]="shutter.mosquito"
                (ngModelChange)="toggleMosquito($event, index)"
                >
                {{ 'ROLLER_SHUTTER_LEGACY|Kwatera' | translate }} {{ letters[index] }}
              </mat-checkbox>
            }
          </form>
        </div>
      }
      @if (hasGrayPolystyrene || concealedStripAvailable || insideConcealedStripAvailable) {
        <div id="gray-polystyrene-form">
          <form class="gray-polystyrene-form">
            @if (hasGrayPolystyrene) {
              <mat-checkbox
                name="gray-polystyrene"
                [checked]="grayPolystyrene != null"
                (change)="toggleGrayPolystyrene($event)"
                >
                <span class="gray-polystyrene-label"
                  >{{ 'ROLLER_SHUTTER_LEGACY|Szary styropian' | translate
                  }}<mat-icon class="mat-16" (click)="showGrayPolystyreneInfo()"
                  >info</mat-icon
                  ></span
                  >
                </mat-checkbox>
              }
              @if (concealedStripAvailable) {
                <mat-checkbox
                  name="concealedStrip"
                  [ngModel]="concealedStrip$ | async"
                  (ngModelChange)="changeConcealedStrip($event)"
                  >
                  {{
                  'ROLLER_SHUTTER_LEGACY|Listwa tynkowa zewnętrzna' | translate
                  }}
                </mat-checkbox>
              }
              @if (insideConcealedStripAvailable) {
                <mat-checkbox
                  name="insideConcealedStrip"
                  [ngModel]="insideConcealedStrip$ | async"
                  (ngModelChange)="changeInsideConcealedStrip($event)"
                  >
                  {{
                  'ROLLER_SHUTTER_LEGACY|Listwa tynkowa wewnętrzna' | translate
                  }}
                </mat-checkbox>
              }
            </form>
          </div>
        }
      </form>
